module.exports = __webpack_public_path__ + "img/futurePoints2.110ff670.png";